module.exports = __webpack_public_path__ + "img/square_bf.80ae1cab.svg";